<template>
    <b-card no-body style="width: 100%; min-height: 350px;">
        <b-card-header>
            <b-row>
                <b-col sm="9">
                    {{ $t("our-open-jobs") }}
                </b-col>
                <b-col sm="3" class="float-right">
                    <b-row>
                            <b-col>
                                <country-flag :country='$root.$i18n.locale' size='normal' class="float-right"/>
                            </b-col>
                            <b-col>
                                <b-form-select v-model="$root.$i18n.locale" :options="langs" size="sm" class="float-right">
                                </b-form-select>
                            </b-col>
                        <!--<b-col sm="3">
                            <country-flag :country='$root.$i18n.locale' size='normal'/>
                        </b-col>
                        <b-col sm="6">
                            <b-form-select v-model="$root.$i18n.locale" :options="langs" size="sm">
                            </b-form-select>
                        </b-col>-->
                    </b-row>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body class="text-left">
            <div v-if="selected === null">
                <div class="text-center">
                    <img class="align-self-center" width="80%" src="@/assets/images/wewantyou.png"/>
                </div>
                <br><br>
                <b>{{ $t("click-for-more-info") }}:</b>
                <br><br>
                <div v-for="listing in jobListings" v-bind:key="listing.title">
                    <b-link href="#" @click="selectListing(listing)">{{ getLocalizedTitle(listing) }}</b-link>
                </div>
                <br>
                <hr>
                <div v-for="listing in trainingListings" v-bind:key="listing.title">
                    <br>
                    <b-link href="#" @click="selectListing(listing)">{{ listing.title }}</b-link>
                </div>
            </div>
            <div v-if="selected !== null">
                <b>{{ this.getLocalizedTitle(this.selected) }}</b>
                <br><br>
                <span style="white-space: pre-wrap">
                        {{ this.getLocalizedContent(this.selected) }}
                    </span>
                <br><br>
                <div>
                    <b>{{ $t("apply-now") }}</b>
                </div>
                <br>
                <JobForm v-bind:jobtitle="this.selected.title" v-bind:station="this.selected.station" v-bind:amazon="this.selected.amazon"></JobForm>
                <b-button @click="resetSelection" class="mt-2">{{ $t("button-back") }}</b-button>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    import JobForm from '@/components/JobForm.vue'
    import CountryFlag from 'vue-country-flag'

    export default {
        name: "JobListing",
        components: {
            JobForm,
            CountryFlag
        },
        data() {
            return {
                selected: null,
                langs: [
                    { value: 'de', html: 'Deutsch' },
                    { value: 'gb', text: 'English' },
                    { value: 'ro', text: 'Românesc' },
                    { value: 'bg', text: 'български' },
                    ],
                listings: [
                    {
                        title: "Stellenangebot - Paketzusteller (m/w/d) - Raum Landau",
                        title_de: "Stellenangebot - Paketzusteller (m/w/d) - Raum Landau",
                        title_gb: "Job offer - parcel delivery (m/w/d) - Area Landau",
                        title_ro: "Oferta de locuri de muncă - livrare colet (m / w / d) - cameră Landau",
                        title_bg: "Предложение за работа - доставка на колети (m / w / d) - стая Landau",
                        type: "job",
                        amazon: false,
                        content_de: "Wir suchen für den Großraum Landau und Neustadt Paketzusteller m/w/d. \n " +
                            "Es handelt sich hierbei um eine Vollzeitstelle von Montag bis Samstag. Die täglichen Arbeitszeiten richten sich nach \n " +
                            "betrieblicher Einteilung, zwischen 9:00 Uhr - 19:00 Uhr, jedoch maximal 10 Stunden am Tag. \n " +
                            "Für die Auslieferung wird ein Transporter zur Verfügung gestellt. \n" +
                            "\n " +
                            "Ihre Aufgaben umfassen folgende Bereiche: \n " +
                            "Tourenplanung \n " +
                            "Auslieferung der Ware an Privat- und Geschäftskunden \n " +
                            "Bedienung eines Handscanners\n " +
                            "\n" +
                            "Voraussetzungen: \n " +
                            "- Führerschein der Kl. B bis 3,5t \n " +
                            "- Erfahrung mit einem Kleintransporter\n " +
                            "- Körperlich fit und belastbar\n " +
                            "- Zeitlich flexibel",
                        content_gb: "We are looking for parcel delivery Landau and Neustadt parcel delivery m / w / d. \n " +
                            "This is a full-time job from Monday to Saturday and daily working hours are based on \n " +
                            "Business division, between 9:00 am - 7:00 pm, but no more than 10 hours a day. \n " +
                            "For the delivery a transporter is provided. \n" +
                            "\n " +
                            "Your tasks include the following areas: \n " +
                            "Tour planning \n " +
                            "Delivery of the goods to private and business customers \n " +
                            "Operating a handheld scanner \n " +
                            "\n" +
                            "Requirements: \n " +
                            "- Driver's license of class B up to 3,5t \n " +
                            "- Experience with a pickup truck \n " +
                            "- Physically fit and resilient \n " +
                            "- flexible in time",
                        content_ro: "Cautam livrare colet Landau si Neustadt livrare colet m / w / d. \n " +
                            "Acesta este un loc de muncă cu normă întreagă de luni până sâmbătă, iar programul de lucru zilnic se bazează pe \n " +
                            "Divizia de afaceri, între orele 9:00 - 19:00, dar nu mai mult de 10 ore pe zi. \n " +
                            "Pentru livrare este furnizat un transportator. \n " +
                            "\n " +
                            "Sarcinile dvs. includ următoarele zone: \n " +
                            "Planificare turistică \n " +
                            "Livrarea mărfurilor către clienții privați și de afaceri \n " +
                            "Operarea unui scaner de mână \n " +
                            "\n" +
                            "Cerințe: \n " +
                            "- Permis de conducere din clasa B până la 3,5t \n " +
                            "- Experiență cu un camionet \n " +
                            "- În formă fizică și rezistentă \n " +
                            "- flexibil în timp",
                        content_bg: "Търсим доставка на колети Landau и Neustadt доставка на колети m / w / d. \n " +
                            "Това е работа на пълен работен ден от понеделник до събота и ежедневното работно време се базира на \n " +
                            "Бизнес деление между 9:00 - 19:00, но не повече от 10 часа на ден. \n " +
                            "За доставката е осигурен транспортер. \n " +
                            "\n" +
                            "Вашите задачи включват следните области: \n " +
                            "Планиране на обиколка \n " +
                            "Доставка на стоките на частни и бизнес клиенти \n " +
                            "Работа на ръчен скенер \n " +
                            "\n" +
                            "Изисквания: \n " +
                            "- шофьорска книжка от клас B до 3,5t \n " +
                            "- Опит с пикап \n " +
                            "- Физически годни и устойчиви \n " +
                            "- гъвкав във времето",
                    },
                    {
                        title: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Mannheim",
                        title_de: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Mannheim",
                        title_gb: "Job offer - driver / parcel delivery agent (m / f / d) full time for Mannheim",
                        title_ro: "Ofertă de locuri de muncă - agent de livrare a șoferului / coletului (m / w / d) cu normă întreagă pentru Mannheim",
                        title_bg: "Оферта за работа - агент за доставка на водач / колет (m / w / d) на пълно работно време за Манхайм",
                        type: "job",
                        amazon: true,
                        station: "dbw1",
                        content_de: "Als Partner für unseren Kunden Amazon suchen wir im Großraum Mannheim jetzt zusätzliche Kollegen.\n" +
                            "\n" +
                            "Wir suchen deshalb ab sofort mehrere\n" +
                            "\n" +
                            "Paketzusteller (m/w)\n" +
                            "\n" +
                            "Deine Kenntnisse und Fertigkeiten:\n" +
                            "-Einsatzbereitschaft, Zuverlässigkeit, freundliches Auftreten\n" +
                            "-Führerschein Klasse B und Fahrpraxis\n" +
                            "-Führungszeugnis ohne Einträge\n" +
                            "\n" +
                            "Das erwartet Dich:\n" +
                            "- Freundliches, mehrsprachiges Team\n" +
                            "- Tolle Arbeitsplätze in neuwertigen Fahrzeugen\n" +
                            "- Faire Bedingungen und ein neues innovatives Konzept\n" +
                            "- Gute, leistungsorientierte Vergütung\n" +
                            "- Festlohn ab 2000 € Brutto, später 2200 €\n" +
                            "- Zusätzlich täglicher Verpflegungs-Zuschlag nach erfolgter Einarbeitung\n" +
                            "- Du arbeitest in einer 5-Tage-Woche von Montag bis Samstag mit einem wechselnden freien Tag\n" +
                            "- Arbeitsstart ist zwischen 10 und 12 Uhr vormittags\n" +
                            "- Deine Pakete sind vorsortiert nach Adressen, haben ein Gewicht von bis zu 6 kg, und sind in Bags untergebracht. Sehr einfaches Beladen in ca. 10 Min. und keine Suche während der Fahrt.\n" +
                            "- Dein Scanner ist dein Navi und Telefon muss nur Start drücken und deinem Navi folgen keine Suche mehr keine Eingabe von Adressen notwendig.\n" +
                            "\n" +
                            "Wir bieten einen sicheren und abwechslungsreichen Arbeitsplatz in einem stark wachsenden Unternehmen mit Aufstiegsmöglichkeiten.\n" +
                            "\n" +
                            "Interesse? Wir laden Dich gerne zu einem Probetag ein.",
                        content_gb: "As a partner for our new customer Amazon, we are now looking for additional colleagues in the greater Mannheim area. \n " +
                            "\n " +
                            "We are looking for several \n" +
                            "\n " +
                            "Package delivery agent (m / w) \n " +
                            "\n " +
                            "Your knowledge and skills: \n " +
                            "Commitment, reliability, friendly demeanor \n " +
                            "Driving license class B and driving practice \n " +
                            "Certificate without entries \n " +
                            "\n " +
                            "That's waiting for you: \n " +
                            "- Friendly, multilingual team \n " +
                            "- Great jobs in new Mercedes Vitos or VW T6 \n " +
                            "- Fair conditions and a new innovative concept \n " +
                            "- Good, performance-based pay. \n " +
                            "- Fixed salary from 2000 € gross \n " +
                            "- Additional daily meal supplement after completion of training \n " +
                            "- You work in a 5-day week from Monday to Saturday with a changing free day \n " +
                            "- Start of work is between 10 and 12 o'clock in the morning \n " +
                            "- Your packages are pre-sorted by address, weigh up to 6 kg, and are stored in bags - very easy loading in about 10 minutes and no search while driving. \n " +
                            "- Your scanner is your navigation system and the phone only needs to press Start and follow your navigation system. No more searching. No need to enter addresses. \n " +
                            "\n" +
                            "We offer a secure and diversified workplace in a fast growing company with opportunities for advancement. \n " +
                            "\n" +
                            "We are pleased to invite you to a trial day.",
                        content_ro: "Ca partener pentru noul nostru client Amazon, acum căutăm colegi suplimentari în zona Mannheim mai mare. \n" +
                            "\n " +
                            "Căutăm mai multe \n " +
                            "\n " +
                            "Agent de livrare a pachetelor (m / w) \n " +
                            "\n " +
                            "Cunoașterea și abilitățile dvs.: \n " +
                            "Angajament, fiabilitate, comportament prietenos \n " +
                            "Permis de conducere clasa B și practică de conducere \n " +
                            "Certificat fără intrări \n " +
                            "\n " +
                            "Asta vă așteaptă: \n " +
                            "- Echipa prietenoasă, multilingvă \n " +
                            "- Locuri de muncă excelente în Mercedes Vitos sau VW T6 \n " +
                            "- Condiții corecte și un nou concept inovator \n " +
                            "- Salariu bun, bazat pe performanță. \n " +
                            "- Salariu fix de la 2000 € brut \n " +
                            "- Supliment suplimentar zilnic după terminarea antrenamentului \n " +
                            "- Lucrați într-o săptămână de 5 zile, de luni până sâmbătă, cu o zi liberă schimbătoare \n " +
                            "- Începerea lucrării este între orele 10 și 12 dimineața \n " +
                            "- Pachetele dvs. sunt pre-sortate după adresă, cântăresc până la 6 kg și sunt păstrate în saci - se încarcă foarte ușor în aproximativ 10 minute și nu se caută în timpul conducerii. \n " +
                            "- Scannerul dvs. este sistemul dvs. de navigație, iar telefonul trebuie doar să apăsați Start și să urmați sistemul dvs. de navigare. Nu mai căutați. Nu este necesar să introduceți adrese. \n " +
                            "\n" +
                            "Oferim un loc de muncă sigur și diversificat într-o companie în creștere rapidă, cu oportunități de avansare. \n " +
                            "\n" +
                            "Suntem încântați să vă invităm într-o zi de proces.",
                        content_bg: "Като партньор на нашия нов клиент Amazon, сега търсим допълнителни колеги в по-голямата зона на Mannheim. \n " +
                            "\n " +
                            "Търсим няколко \n " +
                            "\n " +
                            "Агент за доставка на пакети (m / w) \n " +
                            "\n " +
                            "Вашите знания и умения: \n " +
                            "Ангажираност, надеждност, приятелски поведение \n " +
                            "Шофьорска книжка клас В и шофьорска практика \n " +
                            "Сертификат без записи \n " +
                            "\n " +
                            "Това ви чака: \n " +
                            "- Приятен, многоезичен екип \n " +
                            "- Страхотни работни места в нов Mercedes Vitos или VW T6 \n " +
                            "- Честни условия и нова иновативна концепция \n " +
                            "- Добро заплащане, базирано на резултати. \n " +
                            "- Фиксирана заплата от 2000 € бруто \n " +
                            "- Допълнителна добавка за ежедневно хранене след завършване на обучение \n " +
                            "- Работите в 5-дневна седмица от понеделник до събота с променящ се свободен ден \n " +
                            "- Начало на работа е между 10 и 12 часа сутринта \n " +
                            "- Вашите пакети са предварително сортирани по адрес, тежат до 6 кг и се съхраняват в торби - много лесно зареждане за около 10 минути и без търсене по време на шофиране. \n " +
                            "- Вашият скенер е вашата навигационна система и телефонът трябва само да натисне Старт и следвайте вашата навигационна система. Повече търсене не. Няма нужда да въвеждате адреси. \n " +
                            "\n " +
                            "Ние предлагаме сигурно и разнообразно работно място в бързо развиваща се компания с възможности за напредък. \n " +
                            "\n " +
                            "Радваме се да ви поканим на пробен ден.",
                    },
                    {
                        title: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Raunheim",
                        title_de: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Raunheim",
                        title_gb: "Job offer - driver / parcel delivery agent (m / f / d) full time for Mannheim",
                        title_ro: "Ofertă de locuri de muncă - agent de livrare a șoferului / coletului (m / w / d) cu normă întreagă pentru Raunheim",
                        title_bg: "Оферта за работа - агент за доставка на водач / колет (m / w / d) на пълно работно време за Raunheim",
                        type: "job",
                        amazon: true,
                        station: "dhe1",
                        content_de: "Als Partner für unseren Kunden Amazon suchen wir im Großraum Raunheim jetzt zusätzliche Kollegen.\n" +
                            "\n" +
                            "Wir suchen deshalb ab sofort mehrere\n" +
                            "\n" +
                            "Paketzusteller (m/w)\n" +
                            "\n" +
                            "Deine Kenntnisse und Fertigkeiten:\n" +
                            "-Einsatzbereitschaft, Zuverlässigkeit, freundliches Auftreten\n" +
                            "-Führerschein Klasse B und Fahrpraxis\n" +
                            "-Führungszeugnis ohne Einträge\n" +
                            "\n" +
                            "Das erwartet Dich:\n" +
                            "- Freundliches, mehrsprachiges Team\n" +
                            "- Tolle Arbeitsplätze in neuwertigen Fahrzeugen\n" +
                            "- Faire Bedingungen und ein neues innovatives Konzept\n" +
                            "- Gute, leistungsorientierte Vergütung\n" +
                            "- Festlohn ab 2000 € Brutto, später 2200 €\n" +
                            "- Zusätzlich täglicher Verpflegungs-Zuschlag nach erfolgter Einarbeitung\n" +
                            "- Du arbeitest in einer 5-Tage-Woche von Montag bis Samstag mit einem wechselnden freien Tag\n" +
                            "- Arbeitsstart ist zwischen 10 und 12 Uhr vormittags\n" +
                            "- Deine Pakete sind vorsortiert nach Adressen, haben ein Gewicht von bis zu 6 kg, und sind in Bags untergebracht. Sehr einfaches Beladen in ca. 10 Min. und keine Suche während der Fahrt.\n" +
                            "- Dein Scanner ist dein Navi und Telefon muss nur Start drücken und deinem Navi folgen keine Suche mehr keine Eingabe von Adressen notwendig.\n" +
                            "\n" +
                            "Wir bieten einen sicheren und abwechslungsreichen Arbeitsplatz in einem stark wachsenden Unternehmen mit Aufstiegsmöglichkeiten.\n" +
                            "\n" +
                            "Interesse? Wir laden Dich gerne zu einem Probetag ein.",
                        content_gb: "As a partner for our new customer Amazon, we are now looking for additional colleagues in the greater Raunheim area. \n " +
                            "\n " +
                            "We are looking for several \n" +
                            "\n " +
                            "Package delivery agent (m / w) \n " +
                            "\n " +
                            "Your knowledge and skills: \n " +
                            "Commitment, reliability, friendly demeanor \n " +
                            "Driving license class B and driving practice \n " +
                            "Certificate without entries \n " +
                            "\n " +
                            "That's waiting for you: \n " +
                            "- Friendly, multilingual team \n " +
                            "- Great jobs in new Mercedes Vitos or VW T6 \n " +
                            "- Fair conditions and a new innovative concept \n " +
                            "- Good, performance-based pay. \n " +
                            "- Fixed salary from 2000 € gross \n " +
                            "- Additional daily meal supplement after completion of training \n " +
                            "- You work in a 5-day week from Monday to Saturday with a changing free day \n " +
                            "- Start of work is between 10 and 12 o'clock in the morning \n " +
                            "- Your packages are pre-sorted by address, weigh up to 6 kg, and are stored in bags - very easy loading in about 10 minutes and no search while driving. \n " +
                            "- Your scanner is your navigation system and the phone only needs to press Start and follow your navigation system. No more searching. No need to enter addresses. \n " +
                            "\n" +
                            "We offer a secure and diversified workplace in a fast growing company with opportunities for advancement. \n " +
                            "\n" +
                            "We are pleased to invite you to a trial day.",
                        content_ro: "Ca partener pentru noul nostru client Amazon, acum căutăm colegi suplimentari în zona Raunheim mai mare. \n" +
                            "\n " +
                            "Căutăm mai multe \n " +
                            "\n " +
                            "Agent de livrare a pachetelor (m / w) \n " +
                            "\n " +
                            "Cunoașterea și abilitățile dvs.: \n " +
                            "Angajament, fiabilitate, comportament prietenos \n " +
                            "Permis de conducere clasa B și practică de conducere \n " +
                            "Certificat fără intrări \n " +
                            "\n " +
                            "Asta vă așteaptă: \n " +
                            "- Echipa prietenoasă, multilingvă \n " +
                            "- Locuri de muncă excelente în Mercedes Vitos sau VW T6 \n " +
                            "- Condiții corecte și un nou concept inovator \n " +
                            "- Salariu bun, bazat pe performanță. \n " +
                            "- Salariu fix de la 2000 € brut \n " +
                            "- Supliment suplimentar zilnic după terminarea antrenamentului \n " +
                            "- Lucrați într-o săptămână de 5 zile, de luni până sâmbătă, cu o zi liberă schimbătoare \n " +
                            "- Începerea lucrării este între orele 10 și 12 dimineața \n " +
                            "- Pachetele dvs. sunt pre-sortate după adresă, cântăresc până la 6 kg și sunt păstrate în saci - se încarcă foarte ușor în aproximativ 10 minute și nu se caută în timpul conducerii. \n " +
                            "- Scannerul dvs. este sistemul dvs. de navigație, iar telefonul trebuie doar să apăsați Start și să urmați sistemul dvs. de navigare. Nu mai căutați. Nu este necesar să introduceți adrese. \n " +
                            "\n" +
                            "Oferim un loc de muncă sigur și diversificat într-o companie în creștere rapidă, cu oportunități de avansare. \n " +
                            "\n" +
                            "Suntem încântați să vă invităm într-o zi de proces.",
                        content_bg: "Като партньор на нашия нов клиент Amazon, сега търсим допълнителни колеги в по-голямата зона на Raunheim. \n " +
                            "\n " +
                            "Търсим няколко \n " +
                            "\n " +
                            "Агент за доставка на пакети (m / w) \n " +
                            "\n " +
                            "Вашите знания и умения: \n " +
                            "Ангажираност, надеждност, приятелски поведение \n " +
                            "Шофьорска книжка клас В и шофьорска практика \n " +
                            "Сертификат без записи \n " +
                            "\n " +
                            "Това ви чака: \n " +
                            "- Приятен, многоезичен екип \n " +
                            "- Страхотни работни места в нов Mercedes Vitos или VW T6 \n " +
                            "- Честни условия и нова иновативна концепция \n " +
                            "- Добро заплащане, базирано на резултати. \n " +
                            "- Фиксирана заплата от 2000 € бруто \n " +
                            "- Допълнителна добавка за ежедневно хранене след завършване на обучение \n " +
                            "- Работите в 5-дневна седмица от понеделник до събота с променящ се свободен ден \n " +
                            "- Начало на работа е между 10 и 12 часа сутринта \n " +
                            "- Вашите пакети са предварително сортирани по адрес, тежат до 6 кг и се съхраняват в торби - много лесно зареждане за около 10 минути и без търсене по време на шофиране. \n " +
                            "- Вашият скенер е вашата навигационна система и телефонът трябва само да натисне Старт и следвайте вашата навигационна система. Повече търсене не. Няма нужда да въвеждате адреси. \n " +
                            "\n " +
                            "Ние предлагаме сигурно и разнообразно работно място в бързо развиваща се компания с възможности за напредък. \n " +
                            "\n " +
                            "Радваме се да ви поканим на пробен ден.",
                    },
                    {
                        title: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Völklingen",
                        title_de: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Völklingen",
                        title_gb: "Job offer - driver / parcel delivery agent (m / f / d) full time for Völklingen",
                        title_ro: "Ofertă de locuri de muncă - agent de livrare a șoferului / coletului (m / w / d) cu normă întreagă pentru Völklingen",
                        title_bg: "Оферта за работа - агент за доставка на водач / колет (m / w / d) на пълно работно време за Völklingen",
                        type: "job",
                        amazon: true,
                        station: "dsu1",
                        content_de: "Als Partner für unseren Kunden Amazon suchen wir im Großraum Völklingen jetzt zusätzliche Kollegen.\n" +
                            "\n" +
                            "Wir suchen deshalb ab sofort mehrere\n" +
                            "\n" +
                            "Paketzusteller (m/w)\n" +
                            "\n" +
                            "Deine Kenntnisse und Fertigkeiten:\n" +
                            "-Einsatzbereitschaft, Zuverlässigkeit, freundliches Auftreten\n" +
                            "-Führerschein Klasse B und Fahrpraxis\n" +
                            "-Führungszeugnis ohne Einträge\n" +
                            "\n" +
                            "Das erwartet Dich:\n" +
                            "- Freundliches, mehrsprachiges Team\n" +
                            "- Tolle Arbeitsplätze in neuwertigen Fahrzeugen\n" +
                            "- Faire Bedingungen und ein neues innovatives Konzept\n" +
                            "- Gute, leistungsorientierte Vergütung\n" +
                            "- Festlohn ab 2000 € Brutto, später 2200 €\n" +
                            "- Zusätzlich täglicher Verpflegungs-Zuschlag nach erfolgter Einarbeitung\n" +
                            "- Du arbeitest in einer 5-Tage-Woche von Montag bis Samstag mit einem wechselnden freien Tag\n" +
                            "- Arbeitsstart ist zwischen 10 und 12 Uhr vormittags\n" +
                            "- Deine Pakete sind vorsortiert nach Adressen, haben ein Gewicht von bis zu 6 kg, und sind in Bags untergebracht. Sehr einfaches Beladen in ca. 10 Min. und keine Suche während der Fahrt.\n" +
                            "- Dein Scanner ist dein Navi und Telefon muss nur Start drücken und deinem Navi folgen keine Suche mehr keine Eingabe von Adressen notwendig.\n" +
                            "\n" +
                            "Wir bieten einen sicheren und abwechslungsreichen Arbeitsplatz in einem stark wachsenden Unternehmen mit Aufstiegsmöglichkeiten.\n" +
                            "\n" +
                            "Interesse? Wir laden Dich gerne zu einem Probetag ein.",
                        content_gb: "As a partner for our new customer Amazon, we are now looking for additional colleagues in the greater Mannheim area. \n " +
                            "\n " +
                            "We are looking for several \n" +
                            "\n " +
                            "Package delivery agent (m / w) \n " +
                            "\n " +
                            "Your knowledge and skills: \n " +
                            "Commitment, reliability, friendly demeanor \n " +
                            "Driving license class B and driving practice \n " +
                            "Certificate without entries \n " +
                            "\n " +
                            "That's waiting for you: \n " +
                            "- Friendly, multilingual team \n " +
                            "- Great jobs in new Mercedes Vitos or VW T6 \n " +
                            "- Fair conditions and a new innovative concept \n " +
                            "- Good, performance-based pay. \n " +
                            "- Fixed salary from 2000 € gross \n " +
                            "- Additional daily meal supplement after completion of training \n " +
                            "- You work in a 5-day week from Monday to Saturday with a changing free day \n " +
                            "- Start of work is between 10 and 12 o'clock in the morning \n " +
                            "- Your packages are pre-sorted by address, weigh up to 6 kg, and are stored in bags - very easy loading in about 10 minutes and no search while driving. \n " +
                            "- Your scanner is your navigation system and the phone only needs to press Start and follow your navigation system. No more searching. No need to enter addresses. \n " +
                            "\n" +
                            "We offer a secure and diversified workplace in a fast growing company with opportunities for advancement. \n " +
                            "\n" +
                            "We are pleased to invite you to a trial day.",
                        content_ro: "Ca partener pentru noul nostru client Amazon, acum căutăm colegi suplimentari în zona Mannheim mai mare. \n" +
                            "\n " +
                            "Căutăm mai multe \n " +
                            "\n " +
                            "Agent de livrare a pachetelor (m / w) \n " +
                            "\n " +
                            "Cunoașterea și abilitățile dvs.: \n " +
                            "Angajament, fiabilitate, comportament prietenos \n " +
                            "Permis de conducere clasa B și practică de conducere \n " +
                            "Certificat fără intrări \n " +
                            "\n " +
                            "Asta vă așteaptă: \n " +
                            "- Echipa prietenoasă, multilingvă \n " +
                            "- Locuri de muncă excelente în Mercedes Vitos sau VW T6 \n " +
                            "- Condiții corecte și un nou concept inovator \n " +
                            "- Salariu bun, bazat pe performanță. \n " +
                            "- Salariu fix de la 2000 € brut \n " +
                            "- Supliment suplimentar zilnic după terminarea antrenamentului \n " +
                            "- Lucrați într-o săptămână de 5 zile, de luni până sâmbătă, cu o zi liberă schimbătoare \n " +
                            "- Începerea lucrării este între orele 10 și 12 dimineața \n " +
                            "- Pachetele dvs. sunt pre-sortate după adresă, cântăresc până la 6 kg și sunt păstrate în saci - se încarcă foarte ușor în aproximativ 10 minute și nu se caută în timpul conducerii. \n " +
                            "- Scannerul dvs. este sistemul dvs. de navigație, iar telefonul trebuie doar să apăsați Start și să urmați sistemul dvs. de navigare. Nu mai căutați. Nu este necesar să introduceți adrese. \n " +
                            "\n" +
                            "Oferim un loc de muncă sigur și diversificat într-o companie în creștere rapidă, cu oportunități de avansare. \n " +
                            "\n" +
                            "Suntem încântați să vă invităm într-o zi de proces.",
                        content_bg: "Като партньор на нашия нов клиент Amazon, сега търсим допълнителни колеги в по-голямата зона на Mannheim. \n " +
                            "\n " +
                            "Търсим няколко \n " +
                            "\n " +
                            "Агент за доставка на пакети (m / w) \n " +
                            "\n " +
                            "Вашите знания и умения: \n " +
                            "Ангажираност, надеждност, приятелски поведение \n " +
                            "Шофьорска книжка клас В и шофьорска практика \n " +
                            "Сертификат без записи \n " +
                            "\n " +
                            "Това ви чака: \n " +
                            "- Приятен, многоезичен екип \n " +
                            "- Страхотни работни места в нов Mercedes Vitos или VW T6 \n " +
                            "- Честни условия и нова иновативна концепция \n " +
                            "- Добро заплащане, базирано на резултати. \n " +
                            "- Фиксирана заплата от 2000 € бруто \n " +
                            "- Допълнителна добавка за ежедневно хранене след завършване на обучение \n " +
                            "- Работите в 5-дневна седмица от понеделник до събота с променящ се свободен ден \n " +
                            "- Начало на работа е между 10 и 12 часа сутринта \n " +
                            "- Вашите пакети са предварително сортирани по адрес, тежат до 6 кг и се съхраняват в торби - много лесно зареждане за около 10 минути и без търсене по време на шофиране. \n " +
                            "- Вашият скенер е вашата навигационна система и телефонът трябва само да натисне Старт и следвайте вашата навигационна система. Повече търсене не. Няма нужда да въвеждате адреси. \n " +
                            "\n " +
                            "Ние предлагаме сигурно и разнообразно работно място в бързо развиваща се компания с възможности за напредък. \n " +
                            "\n " +
                            "Радваме се да ви поканим на пробен ден.",
                    },
                    {
                        title: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Grolsheim",
                        title_de: "Stellenangebot - Fahrer / Paketzusteller (m/w/d) in Vollzeit für Grolsheim",
                        title_gb: "Job offer - driver / parcel delivery agent (m / f / d) full time for Grolsheim",
                        title_ro: "Ofertă de locuri de muncă - agent de livrare a șoferului / coletului (m / w / d) cu normă întreagă pentru Grolsheim",
                        title_bg: "Оферта за работа - агент за доставка на водач / колет (m / w / d) на пълно работно време за Grolsheim",
                        type: "job",
                        amazon: true,
                        station: "drp4",
                        content_de: "Als Partner für unseren Kunden Amazon suchen wir im Großraum Grolsheim jetzt zusätzliche Kollegen.\n" +
                            "\n" +
                            "Wir suchen deshalb ab sofort mehrere\n" +
                            "\n" +
                            "Paketzusteller (m/w)\n" +
                            "\n" +
                            "Deine Kenntnisse und Fertigkeiten:\n" +
                            "-Einsatzbereitschaft, Zuverlässigkeit, freundliches Auftreten\n" +
                            "-Führerschein Klasse B und Fahrpraxis\n" +
                            "-Führungszeugnis ohne Einträge\n" +
                            "\n" +
                            "Das erwartet Dich:\n" +
                            "- Freundliches, mehrsprachiges Team\n" +
                            "- Tolle Arbeitsplätze in neuwertigen Fahrzeugen\n" +
                            "- Faire Bedingungen und ein neues innovatives Konzept\n" +
                            "- Gute, leistungsorientierte Vergütung\n" +
                            "- Festlohn ab 2000 € Brutto, später 2200 €\n" +
                            "- Zusätzlich täglicher Verpflegungs-Zuschlag nach erfolgter Einarbeitung\n" +
                            "- Du arbeitest in einer 5-Tage-Woche von Montag bis Samstag mit einem wechselnden freien Tag\n" +
                            "- Arbeitsstart ist zwischen 10 und 12 Uhr vormittags\n" +
                            "- Deine Pakete sind vorsortiert nach Adressen, haben ein Gewicht von bis zu 6 kg, und sind in Bags untergebracht. Sehr einfaches Beladen in ca. 10 Min. und keine Suche während der Fahrt.\n" +
                            "- Dein Scanner ist dein Navi und Telefon muss nur Start drücken und deinem Navi folgen keine Suche mehr keine Eingabe von Adressen notwendig.\n" +
                            "\n" +
                            "Wir bieten einen sicheren und abwechslungsreichen Arbeitsplatz in einem stark wachsenden Unternehmen mit Aufstiegsmöglichkeiten.\n" +
                            "\n" +
                            "Interesse? Wir laden Dich gerne zu einem Probetag ein.",
                        content_gb: "As a partner for our new customer Amazon, we are now looking for additional colleagues in the greater Raunheim area. \n " +
                            "\n " +
                            "We are looking for several \n" +
                            "\n " +
                            "Package delivery agent (m / w) \n " +
                            "\n " +
                            "Your knowledge and skills: \n " +
                            "Commitment, reliability, friendly demeanor \n " +
                            "Driving license class B and driving practice \n " +
                            "Certificate without entries \n " +
                            "\n " +
                            "That's waiting for you: \n " +
                            "- Friendly, multilingual team \n " +
                            "- Great jobs in new Mercedes Vitos or VW T6 \n " +
                            "- Fair conditions and a new innovative concept \n " +
                            "- Good, performance-based pay. \n " +
                            "- Fixed salary from 2000 € gross \n " +
                            "- Additional daily meal supplement after completion of training \n " +
                            "- You work in a 5-day week from Monday to Saturday with a changing free day \n " +
                            "- Start of work is between 10 and 12 o'clock in the morning \n " +
                            "- Your packages are pre-sorted by address, weigh up to 6 kg, and are stored in bags - very easy loading in about 10 minutes and no search while driving. \n " +
                            "- Your scanner is your navigation system and the phone only needs to press Start and follow your navigation system. No more searching. No need to enter addresses. \n " +
                            "\n" +
                            "We offer a secure and diversified workplace in a fast growing company with opportunities for advancement. \n " +
                            "\n" +
                            "We are pleased to invite you to a trial day.",
                        content_ro: "Ca partener pentru noul nostru client Amazon, acum căutăm colegi suplimentari în zona Raunheim mai mare. \n" +
                            "\n " +
                            "Căutăm mai multe \n " +
                            "\n " +
                            "Agent de livrare a pachetelor (m / w) \n " +
                            "\n " +
                            "Cunoașterea și abilitățile dvs.: \n " +
                            "Angajament, fiabilitate, comportament prietenos \n " +
                            "Permis de conducere clasa B și practică de conducere \n " +
                            "Certificat fără intrări \n " +
                            "\n " +
                            "Asta vă așteaptă: \n " +
                            "- Echipa prietenoasă, multilingvă \n " +
                            "- Locuri de muncă excelente în Mercedes Vitos sau VW T6 \n " +
                            "- Condiții corecte și un nou concept inovator \n " +
                            "- Salariu bun, bazat pe performanță. \n " +
                            "- Salariu fix de la 2000 € brut \n " +
                            "- Supliment suplimentar zilnic după terminarea antrenamentului \n " +
                            "- Lucrați într-o săptămână de 5 zile, de luni până sâmbătă, cu o zi liberă schimbătoare \n " +
                            "- Începerea lucrării este între orele 10 și 12 dimineața \n " +
                            "- Pachetele dvs. sunt pre-sortate după adresă, cântăresc până la 6 kg și sunt păstrate în saci - se încarcă foarte ușor în aproximativ 10 minute și nu se caută în timpul conducerii. \n " +
                            "- Scannerul dvs. este sistemul dvs. de navigație, iar telefonul trebuie doar să apăsați Start și să urmați sistemul dvs. de navigare. Nu mai căutați. Nu este necesar să introduceți adrese. \n " +
                            "\n" +
                            "Oferim un loc de muncă sigur și diversificat într-o companie în creștere rapidă, cu oportunități de avansare. \n " +
                            "\n" +
                            "Suntem încântați să vă invităm într-o zi de proces.",
                        content_bg: "Като партньор на нашия нов клиент Amazon, сега търсим допълнителни колеги в по-голямата зона на Raunheim. \n " +
                            "\n " +
                            "Търсим няколко \n " +
                            "\n " +
                            "Агент за доставка на пакети (m / w) \n " +
                            "\n " +
                            "Вашите знания и умения: \n " +
                            "Ангажираност, надеждност, приятелски поведение \n " +
                            "Шофьорска книжка клас В и шофьорска практика \n " +
                            "Сертификат без записи \n " +
                            "\n " +
                            "Това ви чака: \n " +
                            "- Приятен, многоезичен екип \n " +
                            "- Страхотни работни места в нов Mercedes Vitos или VW T6 \n " +
                            "- Честни условия и нова иновативна концепция \n " +
                            "- Добро заплащане, базирано на резултати. \n " +
                            "- Фиксирана заплата от 2000 € бруто \n " +
                            "- Допълнителна добавка за ежедневно хранене след завършване на обучение \n " +
                            "- Работите в 5-дневна седмица от понеделник до събота с променящ се свободен ден \n " +
                            "- Начало на работа е между 10 и 12 часа сутринта \n " +
                            "- Вашите пакети са предварително сортирани по адрес, тежат до 6 кг и се съхраняват в торби - много лесно зареждане за около 10 минути и без търсене по време на шофиране. \n " +
                            "- Вашият скенер е вашата навигационна система и телефонът трябва само да натисне Старт и следвайте вашата навигационна система. Повече търсене не. Няма нужда да въвеждате адреси. \n " +
                            "\n " +
                            "Ние предлагаме сигурно и разнообразно работно място в бързо развиваща се компания с възможности за напредък. \n " +
                            "\n " +
                            "Радваме се да ви поканим на пробен ден.",
                    },
                    /*{
                        title: "Ausbildung zur Fachkraft für KEP (m/w/d)",
                        title_de: "Ausbildung zur Fachkraft für KEP (m/w/d)",
                        type: "training",
                        amazon: false,
                        content_de: "Der Job:\n" +
                            "Die Ausbildungsdauer zur Fachkraft für Kurier-, Express- und " +
                            "Postdienstleistungen beläuft sich auf 2 Jahre; Gegenstand der Ausbildung " +
                            "sind folgende Fertigkeiten und Kenntnisse: Arbeitsorganisation, " +
                            "Arbeitsplanung, Kommunikation und Kooperation, Dienstleistungsangebot, " +
                            "rechtliche Rahmenbedingungen, Qualitätssicherung, Annahme und Abholung, " +
                            "Umschlag und Auslieferung, Kassenführung" +
                            "\n\n" +
                            "Das Angebot:\n " +
                            "- eine Ausbildungsvergütung von durchschnittlich 700 Euro\n " +
                            "- gute Übernahmechancen nach der Ausbildung\n " +
                            "- schnell große Eigenverantwortung durch eigenständige Zustellung\n " +
                            "- vermögenswirksame Leistungen\n " +
                            "\n" +
                            "Die Anforderung:\n " +
                            "- Min. 18 Jahre" +
                            "- Deutsch in Wort und Schrift" +
                            "- min. Führerscheinklasse B bzw. C1 wünschenswert \n " +
                            "- Guter bis sehr guter Hauptschulabschluss oder Mittlere Reife\n " +
                            "- Freude an praxisorientierter Arbeit im Paketgeschäft\n " +
                            "- Begeisterungsfähigkeit und hohes Engagement",
                    }*/
                ],
            }
        },
        methods: {
            selectListing(listing) {
                this.selected = listing;
            },
            resetSelection() {
                this.selected = null;
            },
            getLocalizedTitle(listing) {
                if (listing.hasOwnProperty('title_' + this.$i18n.locale)) {
                    return listing['title_' + this.$i18n.locale];
                } else {
                    return listing['title_de'];
                }
            },
            getLocalizedContent(listing) {
                if (listing.hasOwnProperty('content_' + this.$i18n.locale)) {
                    return listing['content_' + this.$i18n.locale];
                } else {
                    return listing['content_de'];
                }
            }
        },
        computed: {
            jobListings: function () {
                return this.listings.filter(function (listing) {
                    return listing.type === 'job';
                })
            },
            trainingListings: function () {
                return this.listings.filter(function (listing) {
                    return listing.type === 'training';
                })
            }
        }
    }

</script>

<style scoped>

</style>

<i18n xml:lang="json">
    {
        "de": {
            "button-back": "Zurück",
            "apply-now": "JETZT BEWERBEN!",
            "click-for-more-info": "Klicken Sie hier für weitere Informationen",
            "our-open-jobs": "Unsere aktuellen Stellenangebote"
        },
        "gb": {
            "button-back": "Back",
            "apply-now": "APPLY NOW!",
            "click-for-more-info": "Click here for more information",
            "our-open-jobs": "Our currently open job offers"
        },
        "ro": {
            "button-back": "Înapoi",
            "apply-now": "APLICAȚI ACUM!",
            "click-for-more-info": "Faceți clic aici pentru mai multe informații",
            "our-open-jobs": "Locurile noastre vacante actuale"
        },
        "bg": {
            "button-back": "Назад",
            "apply-now": "ПРИЛОЖЕТЕ СЕГА!",
            "click-for-more-info": "Кликнете тук за повече информация",
            "our-open-jobs": "Нашите текущи свободни работни места"
        }
    }
</i18n>
